import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMask } from '@fortawesome/pro-solid-svg-icons';

export default function UnlockWithCreditsCard({ remainingUnlocks, onUnlock }) {
  const [saving, setSaving] = useState(false);

  const handleUnlock = () => {
    setSaving(true);

    onUnlock().finally(() => setSaving(false));
  };

  return (
    <Card className="border-0 shadow">
      <Card.Body className="text-center d-flex flex-column gap-3">
        <div>
          <FontAwesomeIcon className="text-accent" icon={faMask} size="2x" />
          <h3 className="my-0">Unmask contacts</h3>
        </div>
        <div className="py-4 bg-light">
          <h3 className="fw-semi-light">{remainingUnlocks}</h3>
          Remaining
        </div>
        <p className="my-0">Would you like to find out contact information?</p>
        <Button disabled={saving} variant="secondary" onClick={handleUnlock}>
          Unmask this property
        </Button>
      </Card.Body>
    </Card>
  );
}

UnlockWithCreditsCard.propTypes = {
  remainingUnlocks: PropTypes.number.isRequired,
  onUnlock: PropTypes.func.isRequired,
};
